import styled from 'styled-components';

const DialogContainer = styled.div`
  position: relative;
`;

export default DialogContainer;
